document.addEventListener('alpine:init', () => {
  Alpine.data('xFiltersAndSortby', (sectionId) => ({
    t: '',
    show: false,
    showFilterAside: true,
    loading: false,
    isDesktop: false,
    listLayout: false,
    cachedResults: [],
    searchParamsPrev: window.location.search.slice(1),
    searchParamsInitial: window.location.search.slice(1),
    wfCollectionUrl: '',
    deferFilterApply: false,
    wfPending: { format: [], colour: [], flower: [] },
    _lastRenderKey: '',
    init() {
      if (localStorage.getItem("list-layout") == 'list') {
        this.listLayout = true;
      }
      this.wfCollectionUrl = this.$root?.dataset?.collectionUrl || window.location.pathname;
      this.deferFilterApply = Boolean(this.$root?.dataset?.collectionUrl);
      this.wfSyncPendingFromApplied();
      this._lastRenderKey = window.location.pathname + '|' + this.searchParamsInitial;
      this._initLayout();
      this._setListeners();
      this._bindCatalogFilterDelegation();
    },
    _bindCatalogFilterDelegation() {
      if (this._wfCatalogDelegationBound) return;
      this._wfCatalogDelegationBound = true;
      this.$root.addEventListener('click', (e) => {
        const applyBtn = e.target.closest('[data-wf-apply-filters]');
        if (applyBtn) {
          e.preventDefault();
          this.applyFilters();
        }
      });
      this.$root.addEventListener('change', (e) => this._wfCatalogChange(e));
    },
    _wfCatalogCheckboxRoots() {
      const roots = [];
      const drawer = document.querySelector('.form-drawer');
      const aside = document.querySelector('.form-aside');
      if (drawer) roots.push(drawer);
      if (aside) roots.push(aside);
      if (!roots.length) roots.push(this.$root);
      return roots;
    },
    _wfCatalogChange(e) {
      if (!this.deferFilterApply) return;
      const clearAll = e.target.closest('[data-wf-catalog-clear]');
      if (clearAll) {
        if (clearAll.checked) this.wfCatalogPendingClearGroup(clearAll.dataset.wfGroup);
        this._wfSyncPendingCheckboxes();
        return;
      }
      const toggle = e.target.closest('[data-wf-catalog-toggle]');
      if (toggle) {
        this.wfCatalogPendingToggle(toggle.dataset.wfGroup, toggle.dataset.wfKey, toggle.checked);
        this._wfSyncPendingCheckboxes();
      }
    },
    _wfSyncPendingCheckboxes() {
      if (!this.deferFilterApply) return;
      this._wfCatalogCheckboxRoots().forEach((root) => {
        root.querySelectorAll('[data-wf-catalog-toggle]').forEach((input) => {
          input.checked = this.wfCatalogIsPending(input.dataset.wfGroup, input.dataset.wfKey);
        });
        root.querySelectorAll('[data-wf-catalog-clear]').forEach((input) => {
          input.checked = this.wfCatalogIsAllPending(input.dataset.wfGroup);
        });
      });
    },
    _initLayout() {
      let formAside = document.getElementsByClassName('form-aside')[0];
      let formDrawer = document.getElementsByClassName('form-drawer')[0];
      if (window.innerWidth > 767) {
        this.isDesktop = true;
        if (formAside) {
          formAside.setAttribute('id','FacetFiltersForm');
          if (formDrawer) formDrawer.removeAttribute('id');
        } else {
          if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
        }
      } else {
        this.isDesktop = false;
        if (formAside) formAside.removeAttribute('id');
        if (formDrawer) formDrawer.setAttribute('id','FacetFiltersForm');
      }
    },
    _setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state ? event.state.searchParams : this.searchParamsInitial;
        const pathname = (event.state && event.state.pathname) ? event.state.pathname : window.location.pathname;
        const key = pathname + '|' + searchParams;
        if (key === this._lastRenderKey) return;
        this._fetchAndRender(pathname, searchParams);
      }
      window.addEventListener('popstate', onHistoryChange);

      installMediaQueryWatcher('(min-width: 768px)', this._initLayout);
    },
    toggleLayout(theBoolean) {
      this.listLayout = theBoolean;
      localStorage.setItem("list-layout", theBoolean ? "list" : "grid" );
      window.dispatchEvent(new Event('resize'));
    },
    removeFilter(url) {
      const parsed = new URL(url, window.location.origin);
      this._renderPagePath(parsed.pathname, parsed.search.slice(1));
    },
    removeWfFilter(param) {
      this.wfCatalogClearGroup(param.replace('wf_', ''));
    },
    wfCatalogClearGroup(group) {
      const sel = this._getCatalogSelections();
      sel[group] = [];
      this._applyCatalogSelections(sel);
    },
    wfCatalogToggle(group, key, checked) {
      const sel = this._getCatalogSelections();
      const set = new Set(sel[group]);
      if (checked) set.add(key);
      else set.delete(key);
      sel[group] = [...set];
      this._applyCatalogSelections(sel);
    },
    wfCatalogRemove(group, key) {
      const sel = this._getCatalogSelections();
      sel[group] = sel[group].filter((k) => k !== key);
      this._applyCatalogSelections(sel);
    },
    _cloneCatalogSelections(sel) {
      return {
        format: [...(sel.format || [])],
        colour: [...(sel.colour || [])],
        flower: [...(sel.flower || [])],
      };
    },
    wfSyncPendingFromApplied() {
      this.wfPending = this._cloneCatalogSelections(this._getCatalogSelections());
      this._wfSyncPendingCheckboxes();
    },
    wfDiscardPendingFilters() {
      if (this.deferFilterApply) this.wfSyncPendingFromApplied();
    },
    wfCatalogPendingCount(group) {
      return (this.wfPending?.[group] || []).length;
    },
    wfCatalogIsPending(group, key) {
      return (this.wfPending?.[group] || []).includes(key);
    },
    wfCatalogIsAllPending(group) {
      return this.wfCatalogPendingCount(group) === 0;
    },
    wfCatalogPendingClearGroup(group) {
      if (!this.wfPending) this.wfSyncPendingFromApplied();
      this.wfPending[group] = [];
    },
    wfCatalogPendingToggle(group, key, checked) {
      if (!this.wfPending) this.wfSyncPendingFromApplied();
      const set = new Set(this.wfPending[group]);
      if (checked) set.add(key);
      else set.delete(key);
      this.wfPending[group] = [...set];
    },
    applyFilters() {
      clearTimeout(this.t);
      this._closeFilterDrawer();
      const form = document.getElementById('FacetFiltersForm');
      const formParams = form ? this._createSearchParams(form) : '';
      const pending = this._cloneCatalogSelections(this.wfPending || this._getCatalogSelections());
      const { pathname, search } = this._buildCatalogUrl(pending, formParams);
      this._renderPagePath(pathname, search);
    },
    _closeFilterDrawer() {
      if (!this.show) return;
      this.show = false;
      this._filterRemoveFocus();
      if (this.$store?.xPopup) this.$store.xPopup.close();
    },
    onFilterInputChange() {
      if (this.deferFilterApply) return;
      this.onSubmit(0);
    },
    _wfCatalogMaps() {
      return {
        colour: {
          handles: new Set(['pink', 'white', 'red', 'blue', 'yellow', 'purple']),
          labelByHandle: { pink: 'Pink', white: 'White', red: 'Red', blue: 'Blue', yellow: 'Yellow', purple: 'Purple' },
        },
        flower: {
          handles: new Set(['roses', 'tulips', 'carnations', 'daisies', 'sunflowers', 'orchid', 'hydrangea', 'peony', 'babys-breath']),
          labelByHandle: {
            roses: 'Roses', tulips: 'Tulips', carnations: 'Carnations', daisies: 'Daisies',
            sunflowers: 'Sunflowers', orchid: 'Orchids', hydrangea: 'Hydrangeas',
            peony: 'Peonies', 'babys-breath': "Baby's Breath",
          },
        },
      };
    },
    _getCatalogSelections() {
      const maps = this._wfCatalogMaps();
      const base = this.wfCollectionUrl || window.location.pathname;
      let pathTags = [];
      if (window.location.pathname.indexOf(base) === 0 && window.location.pathname.length > base.length) {
        pathTags = window.location.pathname
          .slice(base.length)
          .replace(/^\/+/, '')
          .split('+')
          .map((s) => decodeURIComponent(s).toLowerCase())
          .filter(Boolean);
      }
      const params = new URLSearchParams(window.location.search);
      const colours = pathTags.filter((t) => maps.colour.handles.has(t));
      const flowers = pathTags.filter((t) => maps.flower.handles.has(t));
      params.getAll('wf_colour').forEach((label) => {
        const handle = Object.entries(maps.colour.labelByHandle).find(([, l]) => l === label)?.[0];
        if (handle && !colours.includes(handle)) colours.push(handle);
      });
      params.getAll('wf_flower').forEach((label) => {
        const handle = Object.entries(maps.flower.labelByHandle).find(([, l]) => l === label)?.[0];
        if (handle && !flowers.includes(handle)) flowers.push(handle);
      });
      return {
        colour: colours,
        flower: flowers,
        format: params.getAll('wf_format'),
      };
    },
    _buildCatalogUrl(sel, formParamsStr) {
      const maps = this._wfCatalogMaps();
      const base = this.wfCollectionUrl || window.location.pathname;
      const params = new URLSearchParams(formParamsStr);
      params.delete('wf_colour');
      params.delete('wf_flower');
      params.delete('wf_format');

      const colours = sel.colour || [];
      const flowers = sel.flower || [];
      const formats = sel.format || [];
      const canUseFullPath = formats.length === 0 && colours.length <= 1 && flowers.length <= 1;

      let pathname = base;
      if (canUseFullPath) {
        const tags = [...colours, ...flowers];
        if (tags.length) pathname = `${base}/${tags.join('+')}`;
      } else if (formats.length === 0 && colours.length === 1 && flowers.length > 1) {
        pathname = `${base}/${colours[0]}`;
        flowers.forEach((h) => params.append('wf_flower', maps.flower.labelByHandle[h]));
      } else if (formats.length === 0 && colours.length > 1 && flowers.length === 1) {
        pathname = `${base}/${flowers[0]}`;
        colours.forEach((h) => params.append('wf_colour', maps.colour.labelByHandle[h]));
      } else {
        colours.forEach((h) => params.append('wf_colour', maps.colour.labelByHandle[h]));
        flowers.forEach((h) => params.append('wf_flower', maps.flower.labelByHandle[h]));
      }
      formats.forEach((f) => params.append('wf_format', f));
      return { pathname, search: params.toString() };
    },
    _applyCatalogSelections(sel) {
      const form = document.getElementById('FacetFiltersForm');
      const formParams = form ? this._createSearchParams(form) : '';
      const { pathname, search } = this._buildCatalogUrl(sel, formParams);
      this._renderPagePath(pathname, search);
    },
    renderPagination() {
      var formData = {
        'attributes': {
          'collection-pagination': this.$el.value             
        }
      }; 
      fetch(Shopify.routes.root+'cart/update', {
        method:'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(formData)
      }).then(() => {
        this.cachedResults = [];
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
      }); 
    },
    onSubmit(wait = 500) {
      clearTimeout(this.t);

      const func = () => {
        const searchParams = this._createSearchParams(document.getElementById('FacetFiltersForm'));
        this._renderPage(searchParams);
        if(this.isDesktop) document.getElementById('FormSelectFilter')?.blur();
      }
      
      this.t = setTimeout(() => {
        func();
      }, wait);
    },
    _priceFilterConfig(el) {
      const root = el.classList?.contains('range-price-filter') ? el : el.closest('.range-price-filter');
      return {
        min: Number(root?.dataset.min) || 30,
        max: Number(root?.dataset.max) || 1000,
        step: Number(root?.dataset.step) || 5,
      };
    },
    _snapPriceValue(value, min, max, step) {
      const limit = Number(max);
      let num = Number(value);
      if (Number.isNaN(num)) num = min;
      num = Math.round(num / step) * step;
      if (num < min) num = min;
      if (!Number.isNaN(limit) && num > limit) num = Math.floor(limit / step) * step;
      return num;
    },
    _applyPriceRange(rangeInput, priceInput, pricePreview, range, minVal, maxVal, trackMin) {
      const maxLimit = Number(rangeInput[1].max);
      const min = trackMin ?? Number(rangeInput[0].min);
      const span = maxLimit - min;
      rangeInput[0].value = minVal;
      rangeInput[1].value = maxVal;
      if (priceInput[0]) priceInput[0].value = minVal;
      if (priceInput[1]) priceInput[1].value = maxVal;
      if (pricePreview[0]) pricePreview[0].textContent = minVal;
      if (pricePreview[1]) pricePreview[1].textContent = maxVal;
      if (!range || span <= 0) return;
      range.style.setProperty('--left_range', ((minVal - min) / span) * 100 + '%');
      range.style.setProperty('--right_range', ((maxLimit - maxVal) / span) * 100 + '%');
    },
    rangePrice(el) {
      this.initRange(el);
      const config = this._priceFilterConfig(el);
      const priceGap = config.step;
      const rangeInput = el.querySelectorAll(".range-input input"),
      priceInput = el.querySelectorAll(".price-input"),
      pricePreview = el.querySelectorAll(".price-preview"),
      range = el.querySelector(".slider .progress");

      rangeInput.forEach((input) => {
        input.addEventListener("input", (e) => {
          e.preventDefault();
          const maxLimit = Math.min(Number(rangeInput[1].max), config.max);
          let minVal = this._snapPriceValue(rangeInput[0].value, config.min, maxLimit, config.step);
          let maxVal = this._snapPriceValue(rangeInput[1].value, config.min, maxLimit, config.step);

          if (maxVal - minVal < priceGap) {
            if (e.target.className.includes("range-min")) {
              minVal = Math.max(config.min, maxVal - priceGap);
            } else {
              maxVal = Math.min(maxLimit, minVal + priceGap);
            }
          }

          this._applyPriceRange(rangeInput, priceInput, pricePreview, range, minVal, maxVal, config.min);
        });
      });
    },
    initRange(el) {
      const root = el?.classList?.contains('range-price-filter') ? el : el.closest('.range-price-filter');
      if (!root) return;
      const config = this._priceFilterConfig(root);
      const rangeInput = root.querySelectorAll(".range-input input"),
      priceInput = root.querySelectorAll(".price-input"),
      pricePreview = root.querySelectorAll(".price-preview"),
      range = root.querySelector(".slider .progress");

      if (!rangeInput.length || !rangeInput[1]) return;
      const maxLimit = Math.min(Number(rangeInput[1].max), config.max);
      let minVal = this._snapPriceValue(rangeInput[0].value, config.min, maxLimit, config.step);
      let maxVal = this._snapPriceValue(rangeInput[1].value, config.min, maxLimit, config.step);
      if (maxVal - minVal < config.step) {
        maxVal = Math.min(maxLimit, minVal + config.step);
      }
      this._applyPriceRange(rangeInput, priceInput, pricePreview, range, minVal, maxVal, config.min);
    },
    _createSearchParams(form) {
      const formData = new FormData(form);
      const params = new URLSearchParams(formData);
      params.delete('wf_colour');
      params.delete('wf_flower');
      params.delete('wf_format');
      return params.toString();
    },
    _updateURLHash(searchParams) {
      const qs = searchParams ? '?'.concat(searchParams) : '';
      history.pushState({ searchParams, pathname: window.location.pathname }, '', `${window.location.pathname}${qs}`);
    },
    _fetchAndRender(pathname, searchParams) {
      this.searchParamsPrev = searchParams;
      this._lastRenderKey = pathname + '|' + searchParams;
      this.loading = true;

      const cacheKey = this._lastRenderKey;
      if (this.cachedResults[cacheKey]) {
        try {
          this._renderResults(this.cachedResults[cacheKey]);
        } catch (err) {
          console.error('Filter render failed:', err);
          this.loading = false;
        }
        return;
      }

      const url = `${pathname}?section_id=${sectionId}&${searchParams}`;
      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error(`Filter fetch failed (${response.status})`);
          return response.text();
        })
        .then((responseText) => {
          this.cachedResults[cacheKey] = responseText;
          this._renderResults(responseText);
        })
        .catch((err) => {
          console.error('Filter fetch failed:', err);
          this.loading = false;
        });
    },
    _renderPage(searchParams, updateURLHash = true) {
      const sel = this._getCatalogSelections();
      const { pathname, search } = this._buildCatalogUrl(sel, searchParams);
      this._fetchAndRender(pathname, search);
      if (updateURLHash) {
        const qs = search ? '?'.concat(search) : '';
        history.pushState({ searchParams: search, pathname }, '', `${pathname}${qs}`);
      }
    },
    _renderPagePath(pathname, searchParams, updateURLHash = true) {
      this._fetchAndRender(pathname, searchParams);
      if (updateURLHash) {
        const qs = searchParams ? '?'.concat(searchParams) : '';
        history.pushState({ searchParams, pathname }, '', `${pathname}${qs}`);
      }
    },
    _renderResults(html) {
      try {
        this._renderFilters(html);
        this._renderProductGridContainer(html);
        this._syncProductPerPage(html);
        this._renderProductCount(html);
        if (this.deferFilterApply) this.wfSyncPendingFromApplied();
      } catch (err) {
        console.error('Filter render failed:', err);
      } finally {
        this.loading = false;
      }
    },
    _reinitFilterPanel(panel) {
      if (!panel) return;
      const scope = panel.querySelector('#ProductFilter') || panel;
      if (typeof Alpine !== 'undefined' && typeof Alpine.initTree === 'function') {
        Alpine.initTree(scope);
      }
      scope.querySelectorAll('.range-price-filter').forEach((el) => {
        this.rangePrice(el);
      });
    },
    _renderFilters(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      let blockFiltesDrawer = '.form-drawer';
      let blockFiltesAside = '.form-aside';
      const selectBlockFiltesDrawer = document.querySelector(blockFiltesDrawer);
      const selectBlockFiltesAside = document.querySelector(blockFiltesAside);
      let activeTag = document.getElementById("active-filter-tag")
      const parsedActiveTag = parsedHTML.getElementById("active-filter-tag");

      if (activeTag && parsedActiveTag) {
        activeTag.innerHTML = parsedActiveTag.innerHTML;
      }
      if (selectBlockFiltesDrawer) {
        const parsedDrawer = parsedHTML.querySelector(blockFiltesDrawer);
        if (parsedDrawer) {
          if (this.$el.id) {
            const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
            if (eleOpening) {
              eleOpening.setAttribute('x-data', '{open: true}');
              parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
            }
          }
          selectBlockFiltesDrawer.innerHTML = parsedDrawer.innerHTML;
          this._reinitFilterPanel(selectBlockFiltesDrawer);
        }
      };
      if (selectBlockFiltesAside) {
        const parsedAside = parsedHTML.querySelector(blockFiltesAside);
        if (parsedAside) {
          if (this.$el.id) {
            const eleOpening = parsedHTML.getElementById(this.$el.id) ? parsedHTML.getElementById(this.$el.id).closest('.js-filter') : undefined;
            if (eleOpening) {
              eleOpening.setAttribute('x-data', '{open: true}');
              parsedHTML.getElementById(this.$el.id).closest('.js-filter').innerHTML = eleOpening.innerHTML;
            }
          }
          selectBlockFiltesAside.innerHTML = parsedAside.innerHTML;
          this._reinitFilterPanel(selectBlockFiltesAside);
        }
      };
      this._initLayout();
      this._renderAdvancedFilters(parsedHTML);
      if (this.show) this._closeFilterDrawer();
    },
    _renderAdvancedFilters(html) {
      const destination = document.querySelectorAll(".filter-advanced");
      const source = html.querySelectorAll('.filter-advanced');

      if (source.length > 0 && destination.length > 0) {
        destination.forEach((destination, index) => {
          destination.innerHTML = source[index].innerHTML;
        })
      }
    },
    _renderProductGridContainer(html) {
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.getElementById('ProductGridContainer');
      const destination = document.getElementById('ProductGridContainer');
      if (source && destination) destination.innerHTML = source.innerHTML;
    },
    _renderProductCount(html) {
      const productCountEl = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount');
      if (productCountEl) {
        const count = productCountEl.innerHTML;
        const container = document.getElementById('ProductCount_header');
        const containerDrawer = document.getElementById('ProductCountDrawer');
        if (container) {
          container.innerHTML = count;
          container.classList.remove('loading');
        }
        if (containerDrawer) containerDrawer.innerHTML = count;
      }
    },
    _syncProductPerPage(html) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const container = document.getElementById('ProductPerPage');
      const source = parsedHTML.getElementById('ProductPerPage');
      if (!container || !source) return;

      // Clear every teleport destination so no stale selector lingers.
      document.querySelectorAll('#perpage-collection').forEach((el) => el.replaceChildren());

      container.innerHTML = source.innerHTML;
      if (typeof Alpine !== 'undefined' && typeof Alpine.initTree === 'function') {
        Alpine.initTree(container);
      }

      // Alpine can init the teleport template more than once (its own DOM
      // observer + the explicit initTree above), each time teleporting a
      // copy. De-dupe after it settles so only the latest selector remains.
      requestAnimationFrame(() => {
        document.querySelectorAll('#perpage-collection').forEach((dest) => {
          while (dest.children.length > 1) {
            dest.removeChild(dest.firstElementChild);
          }
        });
      });
    },
    _filterFocus() {
      Alpine.store('xFocusElement').trapFocus('ProductFilter','CloseFilter');
    },
    _filterRemoveFocus() {
      const activeElement = document.getElementById('btn-filter');
      Alpine.store('xFocusElement').removeTrapFocus(activeElement);
    },
    setFilterHeaderHeight() {
      document.documentElement.style.setProperty('--height-sticky-filter',document.getElementById("FacetsWrapperDesktop").offsetHeight + "px");
    },
    setPositionOptionFilter(el) {
      elRect = el.getBoundingClientRect();
      const elPopup = el.getElementsByClassName('popup-above')[0];
      let spacingRight = window.xViewport.innerWidth - elRect.left;
      let checkSpacing = spacingRight - el.innerWidth;
      if (checkSpacing >= 0) {
        elPopup.style.left = '0px';
      } else {
        elPopup.style.left = checkSpacing+ 'px';
      }
    },
    getPopupPosition(el) {
      this.$nextTick(() => {
        const elPopup = el.getElementsByClassName('popup-above')[0];
        if (elPopup) {
          const popupRect = elPopup.getBoundingClientRect();
          if( popupRect.right > window.xViewport.innerWidth){
            elPopup.style.right = 0;
          }
        }
      });
    }
  }));
});